// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"9a00b958bef83066","src_account_account_module_ts":"e4a9edf82ee55a7d","src_app_app_module_ts":"20092830e89998dc","src_fallback_fallback_module_ts":"fc47dba11ccbb04b","i18n-base":"9771310040d5331a","src_app_homepage_homepage_module_ts":"53efded5aa96c66b"}[chunkId] + ".js";
};